/**
 * 页面的 meta 配置
 */
export var EnumPageMeta;
(function (EnumPageMeta) {
    EnumPageMeta["path"] = "protocol-list";
    EnumPageMeta["title"] = "\u534F\u8BAE\u5217\u8868";
    EnumPageMeta["title_en"] = "protocol";
})(EnumPageMeta || (EnumPageMeta = {}));
/**
 * 字段描述 枚举
 */
export var EnumLocaleLabel;
(function (EnumLocaleLabel) {
})(EnumLocaleLabel || (EnumLocaleLabel = {}));
export var EnumGender;
(function (EnumGender) {
})(EnumGender || (EnumGender = {}));
/**
 * 当前页面多语言导出配置
 * 不需要多语言 导出 {en:{},zh:{}} 即可
 */
export default {
    en: {
        [EnumPageMeta.path]: EnumPageMeta.title_en,
    },
    zh: {
        [EnumPageMeta.path]: EnumPageMeta.title,
    },
};
